export const matchConfig = {
    height: 230,
    size: 'mini',
    action: { list: [] },
    columns: [
        {
            label: '发车单号',
            prop: 'dispatchNo',
            sort: true,
            width: 120
        },
        {
            label: '总客户订单',
            prop: 'allCustomerOrderNo',
            sort: true,
            width: 160
        },
        {
            label: '命中客户订单',
            prop: 'matchCustomerOrderNo',
            sort: true,
            width: 160
        },
        {
            label: '未命中客户订单',
            prop: 'noMatchCustomerOrderNo',
            sort: true,
            width: 160
        },
        {
            label: '命中状态',
            prop: 'matchStatusName',
            sort: true,
            width: 100
        }
    ]
};

export const matchRuleConfig = {
    height: 230,
    size: 'mini',
    action: { list: [] },
    columns: [
        {
            label: '配置编码',
            prop: 'configCode',
            sort: true,
            width: 100
        },
        {
            label: '专业公司',
            prop: 'professionalCompanyName',
            sort: true,
            width: 100
        },
        {
            label: '服务平台',
            prop: 'siteName',
            sort: true,
            width: 100
        },
        {
            label: '客户',
            prop: 'customerName',
            sort: true,
            width: 100
        },
        {
            label: '业务模式',
            prop: 'businessModeName',
            sort: true,
            width: 100
        },
        {
            label: '订单类型',
            prop: 'orderTypeName',
            sort: true,
            width: 100
        },
        {
            label: '配送方式',
            prop: 'deliveryTypeName',
            sort: true,
            width: 100
        },
        {
            label: '任务类型',
            prop: 'taskTypeName',
            sort: true,
            width: 100
        },
        {
            label: '是否分拨',
            prop: 'distributionFlagName',
            sort: true,
            width: 100
        },
        {
            label: '是否最后一段分拨',
            prop: 'distributionLastFlagName',
            sort: true,
            width: 160
        }
    ]
};
